import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

/**
 * This component acts as a "gate" that will display
 * certain children OR if the gate/if fails, it will display a fallback
 * component.
 */
const Gate = ({ render, onInit, initialized, loading, open, children, fallback, identifier, loader, ...rest }) => {
  useEffect(() => {
    !initialized && onInit && onInit()
  }, [initialized, onInit])

  if (loading && loader) return loader

  const func = (typeof children === 'function')

  return (
    <React.Fragment>
      {(open && initialized)
        ? (identifier
            ? <React.Fragment key={identifier}>{(func ? children(rest) : children)}</React.Fragment>
            : (func ? children(rest) : children))
        : (fallback || null)}
    </React.Fragment>
  )
}

Gate.defaultProps = {
  loading: false,
  initialized: true,
  open: false
}

Gate.propTypes = {
  /**
   * Mark the gate as loading, the loader component will render if specified
   */
  loading: PropTypes.bool,
  /**
   * Uninitialized gates will trigger the "onInit" method. This method will trigger
   * on every new mount as long as "initialized" is false
   */
  initialized: PropTypes.bool,
  /**
   * Callback function that will trigger when the gate mounts. This should be used
   * to fetch external data/resources to determine state.
   */
  onInit: PropTypes.func,
  /**
   * Is the gate open or closed
   */
  open: PropTypes.bool,
  /**
   * The fallback component to render when the gate has been closed
   */
  fallback: PropTypes.element,
  /**
   * Gated content
   */
  children: PropTypes.any,
  /**
   * Unique ID to use for the gate key
   */
  identifier: PropTypes.any,
  /**
   * Loader component to use when loading is true
   */
  loader: PropTypes.element
}

export default Gate